import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, ShieldCheck, RefreshCw } from 'lucide-react';
import { trackCTAClick } from '../utils/metaPixel';
export function FinalCTA() {
  const checkoutUrl = 'https://www.yenniwellness.com/cart/44544369688711:1';
  return <section id="final-cta" className="bg-[#F0F5F0] py-20 md:py-32 px-4" data-id="element-72">
      <div className="max-w-4xl mx-auto text-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-74">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-olive mb-8" data-id="element-75">
            Este es tu momento de reconexión
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-warm-gray leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-76">
            <p data-id="element-77">
              Tu cuerpo no está roto. Solo necesita que lo escuches y le des las
              señales correctas para descansar. Después de los 40, no necesitas
              resignarte a vivir agotada.
            </p>
            <p data-id="element-78">
              Necesitas armonía, energía y noches de sueño reparador. Esta guía
              es tu primer paso para recuperar el descanso que mereces — de
              forma natural y con mucho amor propio.
            </p>
          </div>

          <div className="py-8 mb-12" data-id="element-79">
            <p className="text-2xl md:text-3xl font-heading font-medium text-sage italic" data-id="element-80">
              "Un buen día comienza con una buena noche de sueño."
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-card max-w-xl mx-auto mb-10 border border-sage/10" data-id="element-81">
            <div className="flex items-center justify-center gap-4 text-warm-gray mb-2" data-id="element-82">
              <span className="line-through text-xl" data-id="element-83">$27.00 USD</span>
              <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-84">
                -63% OFF
              </span>
              <span className="text-4xl font-bold text-olive font-heading" data-id="element-85">
                $9.99 USD
              </span>
            </div>
            <p className="text-warm-accent font-bold text-sm mt-2" data-id="element-86">
              ⏰ Precio de lanzamiento — Solo por 3 días
            </p>
          </div>

          <a href={checkoutUrl} onClick={trackCTAClick} className="inline-block w-full md:w-auto bg-sage hover:bg-sage-dark text-white font-bold py-5 px-12 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-xl mb-8 text-center" data-id="element-87">
            SÍ, QUIERO DORMIR MEJOR POR $9.99
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-olive font-medium" data-id="element-88">
            <span className="flex items-center gap-2" data-id="element-89">
              <Lock className="w-4 h-4 text-sage" data-id="element-90" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-91">
              <Download className="w-4 h-4 text-sage" data-id="element-92" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-2" data-id="element-93">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-94" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-95">
              <RefreshCw className="w-4 h-4 text-sage" data-id="element-96" /> Pago único
            </span>
          </div>

          <p className="text-warm-gray/70 text-xs mt-6 leading-relaxed max-w-lg mx-auto" data-id="element-97">
            🔒 Pago Seguro 100%. Soporte 24/7 disponible vía{' '}
            <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20El%20Interruptor%20del%20Sueño." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-98">
              WhatsApp
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}